import React from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Plane, MapPin, Clock, Euro } from 'lucide-react';

const TaxiCharleroiBruxelles = () => {
  return (
    <>
      <Helmet>
        <title>Taxi Charleroi Bruxelles | Transfert CRL Airport | Prix Fixe</title>
        <meta name="description" content="Taxi Charleroi ↔ Bruxelles. Transfert rapide depuis/vers Charleroi Airport (CRL). Prix fixes à partir de 55€. Réservation 24/7. Vols Ryanair." />
        <meta name="keywords" content="taxi charleroi bruxelles, transfert charleroi airport, taxi CRL, navette charleroi brussels, transport charleroi" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/taxi-charleroi-bruxelles" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black">
        <Navbar />

        <section className="relative pt-32 pb-20 px-4">
          <div className="container mx-auto max-w-6xl text-center">
            <Plane className="w-20 h-20 text-gold mx-auto mb-6" />
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Taxi <span className="text-gold">Charleroi</span> ↔ Bruxelles
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Transfert professionnel depuis/vers Charleroi Airport (CRL)
            </p>
            <Button size="lg" className="bg-gold hover:bg-amber-600 text-black">
              Réserver Mon Transfert
            </Button>
          </div>
        </section>

        <section className="py-16 px-4">
          <div className="container mx-auto max-w-6xl">
            <h2 className="text-3xl font-bold text-white mb-6">
              Transfert Rapide Charleroi Airport - Bruxelles
            </h2>
            <p className="text-lg text-gray-300 mb-8">
              Besoin d'un <strong>taxi depuis Charleroi Airport</strong> vers Bruxelles ? 
              Notre service de <strong>transfert Charleroi</strong> vous offre une solution confortable 
              et fiable pour rejoindre le centre de Bruxelles après votre vol Ryanair ou autre compagnie. 
              <strong>Taxi Charleroi Brussels South</strong> disponible 24h/24.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-12">
              <div className="bg-gray-800/50 border border-gold/20 rounded-lg p-6 text-center">
                <MapPin className="w-12 h-12 text-gold mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-white mb-2">55 km</h3>
                <p className="text-gray-400">Distance Charleroi → Bruxelles</p>
              </div>
              <div className="bg-gray-800/50 border border-gold/20 rounded-lg p-6 text-center">
                <Clock className="w-12 h-12 text-gold mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-white mb-2">50-60 Min</h3>
                <p className="text-gray-400">Temps de trajet moyen</p>
              </div>
              <div className="bg-gray-800/50 border border-gold/20 rounded-lg p-6 text-center">
                <Euro className="w-12 h-12 text-gold mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-white mb-2">À partir de 80€</h3>
                <p className="text-gray-400">Prix fixe garanti (Zone élargie)</p>
              </div>
            </div>

            <div className="bg-gold/10 border border-gold/30 rounded-lg p-8">
              <h2 className="text-2xl font-bold text-white mb-4">
                Réservez Votre Taxi Charleroi - Bruxelles
              </h2>
              <p className="text-gray-300 mb-6">
                Confirmation immédiate - Suivi de vol - Prix fixes sans surprise
              </p>
              <Button size="lg" className="bg-gold hover:bg-amber-600 text-black">
                Calculer Mon Prix
              </Button>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default TaxiCharleroiBruxelles;